import { ApiCategoryDiagnose } from '../api-types/category-diagnose.api';
import { CategoryDiagnose } from '../app-types/category-diagnose.app';

export const transformApiCategoryDiagnoseToAppCategoryDiagnose = (input: ApiCategoryDiagnose): CategoryDiagnose => {
	if (!input) return { id: 0, description: '' };
	return { id: input.id, description: input.description };
};

export const transformApiCategoryDiagnosesToAppCategoryDiagnoses = (
	input: ApiCategoryDiagnose[],
): CategoryDiagnose[] => {
	const output: ApiCategoryDiagnose[] = input ?? [];
	return output.map(transformApiCategoryDiagnoseToAppCategoryDiagnose);
};
